// extracted by mini-css-extract-plugin
export var addonsTitle = "newStyles-module--addonsTitle--75cf7";
export var allFeaturesTittle = "newStyles-module--allFeaturesTittle--b3f53";
export var arrow = "newStyles-module--arrow--7c766";
export var arrowActive = "newStyles-module--arrowActive--2e261";
export var buttonHidden = "newStyles-module--buttonHidden--e56e5";
export var buttonVisible = "newStyles-module--buttonVisible--b8c27";
export var casesColumn = "newStyles-module--casesColumn--92b10";
export var casesTitle = "newStyles-module--casesTitle--0e6ef";
export var comparisonLink = "newStyles-module--comparisonLink--27a5e";
export var downloadLink = "newStyles-module--downloadLink--e9984";
export var fixedHeader = "newStyles-module--fixedHeader--c80e4";
export var heroHighlight = "newStyles-module--heroHighlight--bf197";
export var infoItem = "newStyles-module--infoItem--28fb1";
export var infoList = "newStyles-module--infoList--60ad7";
export var priceColumn = "newStyles-module--priceColumn--9d186";
export var priceTab = "newStyles-module--priceTab--8647f";
export var priceTabActive = "newStyles-module--priceTabActive--35c11";
export var priceTabs = "newStyles-module--priceTabs--24247";
export var sectionPrice = "newStyles-module--sectionPrice--b01ad";
export var sectionSpaceFull = "newStyles-module--sectionSpaceFull--c73a2";
export var showAll = "newStyles-module--showAll--21a8a";
export var showAllAction = "newStyles-module--showAllAction--f9839";
export var tariffDescription = "newStyles-module--tariffDescription--ef5b6";
export var tariffHeader = "newStyles-module--tariffHeader--4ec4d";
export var tariffOptionItem = "newStyles-module--tariffOptionItem--7e59d";
export var tariffOptionsList = "newStyles-module--tariffOptionsList--397ec";
export var tariffTitle = "newStyles-module--tariffTitle--56076";
export var title = "newStyles-module--title--99fde";
export var totalPrice = "newStyles-module--totalPrice--2e2d5";
export var totalPriceCount = "newStyles-module--totalPriceCount--65536";
export var totalPriceOld = "newStyles-module--totalPriceOld--25a71";
export var totalPriceRequest = "newStyles-module--totalPriceRequest--df5a4";
export var withTooltipItem = "newStyles-module--withTooltipItem--fa2da";
export var wrapper = "newStyles-module--wrapper--46583";
export var wrapperPrice = "newStyles-module--wrapperPrice--55ee6";
export var wrapperPriceFull = "newStyles-module--wrapperPriceFull--849f8";
export var wrapperPriceMulti = "newStyles-module--wrapperPriceMulti--98b27";
export var wrapperPriceSingle = "newStyles-module--wrapperPriceSingle--e814b";
export var wrapperPriceWithCases = "newStyles-module--wrapperPriceWithCases--4ff36";